import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  updateButtonHref(event) {
    // Allow both click and keyboard activation (Enter/Space)
    if (
      event.type === "keydown" &&
      !(event.key === " " || event.key === "Enter")
    )
      return;

    event.preventDefault();

    const checked = this.element.querySelector('input[name="mode"]:checked');

    if (checked) {
      const mode = checked.value;
      const startButton = document.getElementById("start-button");
      const quizId = startButton?.getAttribute("data-quiz-id") || "";
      const firstIndex = startButton?.getAttribute("data-first-index") || "";
      const url = `/quiz_item_responses/${firstIndex}?mode=${mode}&quiz_id=${quizId}&apply_mode=1`;
      window.location.href = url;
    } else {
      document.getElementById("modeMsg").innerText =
        "Please select one mode to continue";
    }
  }
}
